var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.ctripCardData.length > 0 ? _c('div', [_c('div', {
    ref: "ctripCardDom",
    staticClass: "ctrip-card-list",
    on: {
      "scroll": _vm.scrollCard
    }
  }, [_vm._l(_vm.ctripCardData, function (item, i) {
    return _c('ctripCard', {
      key: i,
      staticClass: "card-item",
      attrs: {
        "card-data": item,
        "index": i
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.goDetail(item, i);
        }
      }
    });
  }), _c('div', {
    staticClass: "right"
  })], 2)]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };